import React from 'react'
import { withStyles } from 'material-ui/styles'
import { connect } from 'react-redux'
import * as selectors from 'selectors'
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'material-ui/Table'
import Paper from 'material-ui/Paper'
import { CurrenciesIcon } from '../assets/currencies'
import { orderBy } from 'lodash'
import { green, red } from 'material-ui/colors'

const styles = theme => ({
  paper: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  red: {
    color: red[500],
  },
  green: {
    color: green[500],
  },
  icon: {
    fontSize: '3em',
  },
})

const colour = trend => {
  if (trend < 0) {
    return 'red'
  } else if (trend > 0) {
    return 'green'
  }
}

const Status = ({ classes, cryptoArray }) => (
  <div className={classes.root}>
    <Paper className={classes.paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Logo</TableCell>
            <TableCell>Currency</TableCell>
            <TableCell>Name</TableCell>
            <TableCell numeric>Value in BTC</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {orderBy(cryptoArray, ['priority'], ['desc']).map(c => {
            return (
              <TableRow key={c.code}>
                <TableCell>
                  <CurrenciesIcon currency={c.code} width={50} height={50} />
                </TableCell>
                <TableCell>{c.code}</TableCell>
                <TableCell>{c.name}</TableCell>
                <TableCell numeric className={classes[colour(c.trend)]}>
                  {c.value}
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </Paper>
  </div>
)

const mapStateToProps = state => ({
  cryptoArray: selectors.cryptoArray(state),
})

const mapDispatchToProps = dispatch => ({})

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(Status)
)



// WEBPACK FOOTER //
// ./src/components/Status.js